import { authFetch } from './authFetch';
import { API_BASE } from './version';

export interface ScheduleView {
  id: string;
  name: string;
  task_type: string;
  prompt: string;
  repos: string[];
  cron: string;
  enabled: boolean;
  provider?: string | null;
  model?: string | null;
  last_run_at?: string | null;
  last_run_status?: string | null;
  updated_at?: string | null;
}

export interface SchedulesPayload { schedules: ScheduleView[]; gated: boolean; allowedProviders: string[] }

export interface ScheduleInput {
  name: string;
  task_type: string;
  prompt: string;
  repos: string[];
  cron: string;
  enabled: boolean;
  provider?: string;
  model?: string;
}

async function readErr(r: Response, fallback: string): Promise<string> {
  try {
    const j = await r.json();
    return j?.error?.message ?? j?.message ?? fallback;
  } catch { return fallback; }
}

const base = (projectId: string) => `${API_BASE}/projects/${encodeURIComponent(projectId)}/schedules`;

export async function fetchSchedules(projectId: string): Promise<SchedulesPayload> {
  const r = await authFetch(base(projectId), { method: 'GET' });
  if (!r.ok) throw new Error(await readErr(r, 'Failed to load schedules'));
  return (await r.json()).data as SchedulesPayload;
}

export async function createSchedule(projectId: string, body: ScheduleInput): Promise<{ id: string }> {
  const r = await authFetch(base(projectId), { method: 'POST', body: JSON.stringify(body) });
  if (!r.ok) throw new Error(await readErr(r, 'Failed to create schedule'));
  return (await r.json()).data;
}

export async function updateSchedule(projectId: string, sid: string, body: ScheduleInput): Promise<{ id: string }> {
  const r = await authFetch(`${base(projectId)}/${encodeURIComponent(sid)}`, { method: 'PUT', body: JSON.stringify(body) });
  if (!r.ok) throw new Error(await readErr(r, 'Failed to update schedule'));
  return (await r.json()).data;
}

export async function deleteSchedule(projectId: string, sid: string): Promise<void> {
  const r = await authFetch(`${base(projectId)}/${encodeURIComponent(sid)}`, { method: 'DELETE' });
  if (!r.ok) throw new Error(await readErr(r, 'Failed to delete schedule'));
}
